import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs/operators';
import { AdapterBuilder } from '../../models/builders/adapter.builder';
import { Adapter } from '../../models/adapter';

const adapterBody = (adapter: Adapter) => ({
  name: adapter.name,
  type: adapter.type
});

@Injectable()
export class AdapterApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }adapters`;
  }

  createAdapter(adapter) {
    return this.httpClient.post(this.apiUrl, adapterBody(adapter)).pipe(map(AdapterBuilder.fromJson));
  }

  deleteAdapter(adapter: Adapter) {
    return this.httpClient.delete(`${ this.apiUrl }/${ adapter.hash }`);
  }

  getAdapter(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(AdapterBuilder.fromJson)
      );
  }

  getAdapters() {
    return this.httpClient.get(`${ this.apiUrl }`).pipe(map(AdapterBuilder.fromList));
  }

  updateAdapter(adapter: Adapter) {
    return this.httpClient.put(`${ this.apiUrl }/${ adapter.hash }`, adapterBody(adapter));
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/adapter-api.service.ts